import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "../i18n/translations";

const I18nContext = createContext(null);
const KEY = "gai_lang";

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return localStorage.getItem(KEY) || "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "en" ? "en" : "fr"), []);
  const toggleLang = useCallback(() => setLangState((l) => (l === "fr" ? "en" : "fr")), []);

  const t = useCallback(
    (key) => {
      const parts = key.split(".");
      let ref = translations[lang];
      for (const p of parts) {
        ref = ref?.[p];
        if (ref === undefined) return key;
      }
      return ref;
    },
    [lang]
  );

  // Helper for bilingual fields coming from backend (object { fr, en } or plain string)
  const tr = useCallback(
    (field) => {
      if (!field) return "";
      if (typeof field === "string") return field;
      return field[lang] || field.fr || field.en || "";
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, toggleLang, t, tr }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
